import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PurchasesPage } from "@/features/spend/PurchasesPage";

const search = z.object({
  tab: z.enum(["orders", "bills"]).optional(),
  status: z.string().optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/purchases")({
  validateSearch: search,
  component: () => <PurchasesPage search={Route.useSearch()} />,
});
